// --------------------------------------------
// Cart suggestions - Add to cart
// Handles adding complementary products from the cart flyout and refreshes cart sections
// (flyout, count, shipping banner) via Shopify Sections API without page reload.
// --------------------------------------------
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-wb-suggestion-id]');
  if (!btn || btn.dataset.loading) return;
  
  const variantId = btn.dataset.wbSuggestionId;
  btn.dataset.loading = 'true';
  btn.disabled = true;

  const cartUrl = window.theme?.routes?.cartUrl || '/cart';

  fetch(`${cartUrl}/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      items: [{ id: parseInt(variantId), quantity: 1 }],
      sections: ['cart-flyout', 'cart-count', 'shipping-banner']
    })
  })
  .then(r => r.json())
  .then(data => {
    if (data.sections) {
      Object.entries(data.sections).forEach(([sectionId, html]) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector(`[data-cart-section="${sectionId}"]`);
        const currentSections = document.querySelectorAll(`[data-cart-section="${sectionId}"]`);
        
        currentSections.forEach(currentSection => {
          if (sectionId === 'cart-count') {
            const newCount = newSection.querySelector('[data-count]');
            const currentCount = currentSection.querySelector('[data-count]');
            if (newCount && currentCount) {
              currentCount.setAttribute('data-count', newCount.dataset.count);
              currentCount.textContent = newCount.textContent;
              currentCount.setAttribute('aria-label', newCount.getAttribute('aria-label'));
            }
          } else {
            currentSection.innerHTML = newSection.innerHTML;
          }
        });
      });
    }
  })
  .catch(() => {
    btn.disabled = false;
    delete btn.dataset.loading;
  });
});

// --------------------------------------------
// Header icon triggers duplicated in brand-navigation.liquid.
// Opens/closes the single search & cart dialogs rendered once in
// header.liquid, directly via the native <dialog> API — bypassing
// toggle-button-component's internal aria-controls resolution, which
// we could not get to fire reliably for these cross-section buttons.
// --------------------------------------------
(function () {
  document.querySelectorAll('[data-wb-icon-trigger]').forEach(function (button) {
    button.addEventListener('click', function () {
      var targetId = button.getAttribute('aria-controls');
      var dialog = targetId && document.getElementById(targetId);
      if (!dialog) return;

      var isOpen = dialog.hasAttribute('open');
      isOpen ? dialog.close() : dialog.showModal();
      button.setAttribute('aria-expanded', String(!isOpen));
    });
  });
})();